import React from 'react';
import PropTypes from 'prop-types';
import {
  FormField,
} from '@iris-platform/iris-react-ui';
import { withApollo } from 'react-apollo';
import {
  prop,
} from 'ramda';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core';


const styles = () => ({
  formRoot: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',
    paddingBottom: '2em',
  },
});


class TeamRoleHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchError: null,
    };
  }


  render() {
    const {
      name, readOnly, onChange, classes,
    } = this.props;
    const {
      searchError,
    } = this.state;

    return (
      <FormControl
        className={classes.formRoot}
        error={searchError}
      >
        <FormLabel focused={false}>Name</FormLabel>
        <FormField
          placeholder="Role name"
          value={name}
          onChange={e => onChange('name', e.target.value)}
          disabled={readOnly}
        />
        <br />
        {searchError && <FormHelperText id="add-user-error">{prop('message', searchError)}</FormHelperText>}
      </FormControl>
    );
  }
}

TeamRoleHeader.propTypes = {
  name: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(withApollo(TeamRoleHeader));
